import React from "react";
import {
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Typography,
} from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Popup({ title, bodytext, errorcode }) {
  const handleRedirect = () => {
    window.open("https://canvas.asu.edu/", "_self");
  };
  return (
    <Dialog
      PaperProps={{
        style: {
          borderRadius: 8,
          boxShadow: "0 0 0 5px #333",
          minHeight: "20vh",
          minWidth: "30%",
        },
      }}
      open={true}
      TransitionComponent={Transition}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{ bgcolor: "#081627", color: "#FFC627" }}
      >
        {title}
      </DialogTitle>
      <DialogContent id="alert-dialog-description" sx={{ bgcolor: "#081627", color: "#FFC627", pt: 10 }}>
          <Typography>{bodytext}</Typography>
          <Typography sx={{ pt: 3 }}>{"Error Code: " + errorcode}</Typography>
      </DialogContent>
      <DialogActions sx={{ bgcolor: "#081627", color: "#FFC627" }}>
        <Button
          onClick={handleRedirect}
          sx={{
            m: 0,
            color: "#FFC627",
            backgroundColor: "rgba(255, 198, 39, 0.2);",
            "&:hover": { backgroundColor: "#FFC627", color: "#000" },
          }}
          aria-label="close"
        >
          Go To ASU CANVAS
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default Popup;
